class VariantSwatches extends HTMLElement {
  connectedCallback() {
    this.card = this.closest('.card-wrapper, .grid__item');
    this.baseUrl = this.dataset.productUrl;

    const dataEl = this.querySelector('.variant-data');
    try {
      this.variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      this.variants = [];
    }

    this.selection = {};
    this.querySelectorAll('.card-swatch.is-active').forEach((swatch) => {
      this.selection[swatch.dataset.optionPosition] = swatch.dataset.optionValue;
    });

    this.updateSizeVisibility();
    this.updateVariant();

    this.addEventListener('click', this.onSwatchClick.bind(this));

    const atcBtn = this.querySelector('.card-atc__button');
    if (atcBtn) atcBtn.addEventListener('click', this.onAddToCart.bind(this));
  }

  onSwatchClick(event) {
    const swatch = event.target.closest('.card-swatch');
    if (!swatch) return;
    event.preventDefault();

    const position = swatch.dataset.optionPosition;
    const value = swatch.dataset.optionValue;

    const row = swatch.closest('.card-swatches');
    row.querySelectorAll('.card-swatch').forEach((s) => s.classList.remove('is-active'));
    swatch.classList.add('is-active');

    this.selection[position] = value;
    this.updateSizeVisibility();
    this.updateVariant();
  }

  updateSizeVisibility() {
    const colorRow = this.querySelector('.card-option--color');
    const sizeRow = this.querySelector('.card-option--size');
    if (!sizeRow) return;
    if (!colorRow) {
      sizeRow.hidden = false;
      return;
    }
    const colorPos = colorRow.dataset.optionPosition;
    sizeRow.hidden = !this.selection[colorPos];
  }

  updateVariant() {
    const match = this.variants.find((variant) =>
      Object.keys(this.selection).every(
        (pos) => String(variant.options[pos - 1]) === String(this.selection[pos])
      )
    );

    this.currentMatch = match || null;

    if (match) {
      // Swap the primary card image
      if (match.image && this.card) {
        const img = this.card.querySelector('.card__media .media img');
        if (img) {
          img.srcset = '';
          img.src = match.image;
        }
      }

      // Update product links + theme's hidden variant input
      if (this.card) {
        const url = `${this.baseUrl}?variant=${match.id}`;
        this.card.querySelectorAll('a[href*="/products/"]').forEach((a) => {
          a.href = url;
        });
        const idInput = this.card.querySelector('input[name="id"]');
        if (idInput) idInput.value = match.id;
      }

      // Update this component's own ATC input
      const atcInput = this.querySelector('.card-atc__variant-id');
      if (atcInput) atcInput.value = match.id;
    }

    // Reveal ATC only when every option has a selection
    const totalOptions = this.querySelectorAll('.card-option').length;
    const chosen = Object.keys(this.selection).length;
    const atc = this.querySelector('.card-atc');
    const btn = this.querySelector('.card-atc__button');

    if (atc) atc.hidden = chosen < totalOptions;

    if (btn) {
      if (match && match.available) {
        btn.disabled = false;
        btn.textContent = 'Add to cart';
      } else {
        btn.disabled = true;
        btn.textContent = match ? 'Sold out' : 'Unavailable';
      }
    }
  }

  onAddToCart(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.currentMatch || !this.currentMatch.available) return;

    const btn = this.querySelector('.card-atc__button');
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: this.currentMatch.id, quantity: 1 }] }),
    })
      .then((response) => response.json())
      .then(() => {
        btn.textContent = 'Added ✓';
        this.refreshCart();
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 1500);
      })
      .catch(() => {
        btn.textContent = 'Try again';
        btn.disabled = false;
      });
  }

  // Refresh the theme's cart drawer / count (Dawn-based)
  refreshCart() {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotification = document.querySelector('cart-notification');

    fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`)
      .then((r) => r.json())
      .then((sections) => {
        if (cartDrawer && sections['cart-drawer']) {
          const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          const newInner = html.querySelector('cart-drawer');
          if (newInner) cartDrawer.innerHTML = newInner.innerHTML;
          cartDrawer.classList.remove('is-empty');
          if (typeof cartDrawer.open === 'function') cartDrawer.open();
        }
        // Update the header cart bubble
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          const newBubble = html.getElementById('cart-icon-bubble');
          if (newBubble) bubble.innerHTML = newBubble.innerHTML;
        }
      })
      .catch(() => {});
  }
}

customElements.define('variant-swatches', VariantSwatches);